const axios = require('axios')
const toSnakeCase = require('snakecase-keys')

const toCamelCase = require('./toCamelCase')

const validateConfig = (config, key) => {
  if (!config[key]) {
    throw new Error(`Invalid configuration: ${key} is required.`)
  }
}

class PlurallClient {
  constructor(config = {}) {
    validateConfig(config, 'accessToken')
    validateConfig(config, 'apiURL')

    this.profileURL = config.profileURL || config.apiURL
    this.onError = config.onError
    this.disableAutoCamelize = config.disableAutoCamelize

    const clientLibrary = config.clientLibrary || axios
    let headers = {
      accept: config.accept || 'vnd.plurall.api.v2+json',
      'Content-Type': config.contentType || 'application/json',
      client: config.client || 'somos-client-v1',
      Authorization: `Bearer ${config.accessToken}`,
    }

    if (config.computeHours) {
      headers['COMPUTE-HOURS-LOGGED'] = config.computeHours
    }

    this.client = clientLibrary.create({
      baseURL: config.apiURL,
      headers,
    })

    this.handleError = this.handleError.bind(this)
    this.camelizeResponse = this.camelizeResponse.bind(this)
    this.getProfile = this.getProfile.bind(this)
    this.getMenu = this.getMenu.bind(this)
    this.get = this.get.bind(this)
    this.post = this.post.bind(this)
    this.put = this.put.bind(this)
    this.delete = this.delete.bind(this)
  }

  handleError(error) {
    if (this.onError) {
      this.onError(error)
    }

    return { error }
  }

  camelizeResponse({ data }) {
    return this.disableAutoCamelize ? data : toCamelCase(data)
  }

  getProfile() {
    return this.get('/profiles', {
      baseURL: this.profileURL,
    })
  }

  async getMenu(type = 'menu-web-app') {
    const { menu } = await this.get(`/menus/${type}`, {
      baseURL: `${this.profileURL}/networks/0/roles/0/users/0`,
    })
    return menu
  }

  async get(...args) {
    return this.client
      .get(...args)
      .then(this.camelizeResponse)
      .catch(this.handleError)
  }

  async post(path, body, ...args) {
    return this.client
      .post(path, toSnakeCase(body), ...args)
      .then(this.camelizeResponse)
      .catch(this.handleError)
  }

  async put(path, body, ...args) {
    return this.client
      .put(path, toSnakeCase(body), ...args)
      .then(this.camelizeResponse)
      .catch(this.handleError)
  }

  async delete(...args) {
    return this.client
      .delete(...args)
      .then(this.camelizeResponse)
      .catch(this.handleError)
  }
}

module.exports = PlurallClient
